<div class="modal-overlay" (click)="closeModal()">
  <div class="modal-content">
    <img [src]="imageUrl" alt="Preview" />
  </div>
</div>
